import "./App.css";
import { BrowserRouter, Navigate, Outlet, Route, Routes } from "react-router-dom";
import { Layout } from "./components/Layout";
import { RequireAdmin } from "./components/RequireAdmin";
import { AdminHome, RequirePermission } from "./components/RequirePermission";
import { AuthProvider } from "./context/AuthContext";
import { SiteContentProvider } from "./context/SiteContentContext";
import HomePage from "./pages/HomePage";
import WhatWeDoPage from "./pages/WhatWeDoPage";
import ServicesPage from "./pages/ServicesPage";
import ContactPage from "./pages/ContactPage";
import AdminLayout from "./pages/admin/AdminLayout";
import AdminLoginPage from "./pages/admin/LoginPage";
import AdminVisitorsPage from "./pages/admin/VisitorsPage";
import AdminContactsPage from "./pages/admin/ContactsPage";
import AdminContentPage from "./pages/admin/ContentPage";
import AdminVideosPage from "./pages/admin/VideosPage";
import AdminAdminsPage from "./pages/admin/AdminsPage";

function PublicLayout() {
  return (
    <Layout>
      <Outlet />
    </Layout>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <SiteContentProvider>
            <Routes>
              <Route path="/admin/login" element={<AdminLoginPage />} />
              <Route
                path="/admin"
                element={
                  <RequireAdmin>
                    <AdminLayout />
                  </RequireAdmin>
                }
              >
                <Route index element={<AdminHome />} />
                <Route
                  path="visitors"
                  element={
                    <RequirePermission feature="visitors">
                      <AdminVisitorsPage />
                    </RequirePermission>
                  }
                />
                <Route
                  path="contacts"
                  element={
                    <RequirePermission feature="contacts">
                      <AdminContactsPage />
                    </RequirePermission>
                  }
                />
                <Route
                  path="content"
                  element={
                    <RequirePermission feature="website">
                      <AdminContentPage />
                    </RequirePermission>
                  }
                />
                <Route
                  path="videos"
                  element={
                    <RequirePermission feature="videos">
                      <AdminVideosPage />
                    </RequirePermission>
                  }
                />
                <Route path="admins" element={<AdminAdminsPage />} />
              </Route>
              <Route element={<PublicLayout />}>
                <Route path="/" element={<HomePage />} />
                <Route path="/what-we-do" element={<WhatWeDoPage />} />
                <Route path="/services" element={<ServicesPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Route>
            </Routes>
          </SiteContentProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
